/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  app.Router = Backbone.Router.extend({
    forceFetch: false,
    routes: {
      '': 'handleRoute',
      'p:page(/)': 'handleRoute'
    },
    attachedOptions: [
      'collection',
      'type',
      'allowed',
      'currencies',
      'currency',
      'allowedCookieParams',
      'mode',
    ],
    additionalOptions: [],
    currency: app.currentCurrency,
    /**
     * Предыдущие измененные параметры должны учитываться в последующих проверках измененённых параметрах.
     */
    prevChangedParamsKeys: [],
    allowed: [
      'sort',
      'per-page',
      'viewtype',
      'f',
      'mode',
      'currency',
      'priority_ids',
      'priority_sids',
      'priority_parent_ids',
      'is_catalog',
    ],
    // параметры при изменении которых не нужно запрашивать товары, но сохранять при navigate
    navigateParams: ['c_id'],
    priorityKeys: ['priority_ids', 'priority_sids', 'priority_parent_ids'],
    /**
     * @inheritDoc
     */
    initialize: function (options) {
      Backbone.Router.prototype.initialize.apply(this, arguments);
      this.attachOptions(options);
      this.convertedFilters = false;
      this.isRouterNavigate = false;
      this.listenTo(this.collection, 'page-range-error', this.redirect);
      this.listenTo(
        Backbone,
        app.CQC_COMMANDS_TYPES_TO_EVENTS[app.CQC_COMMAND_TYPES.currencyUpdate],
        this.updateCurrencyOnPage
      );
      this.listenTo(
        Backbone,
        app.CQC_COMMANDS_TYPES_TO_EVENTS[app.CQC_COMMAND_TYPES.searchQueryUpdate],
        this.updateSearchQueryOnPage
      );
      Backbone.trigger('router:inited', this);
    },

    /**
     * Обновление валюты на странице
     * @param {Object} data - данные с валютой
     */
    updateCurrencyOnPage: function (data) {
      var newCurrencyName = data.currency.name;
      var currentCurrency = this.currencies.getCurrent();
      if (newCurrencyName !== currentCurrency.get('name')) {
        this.currencies.setCurrent(newCurrencyName);
        _.merge(this.currency, this.currencies.getCurrent().toJSON());
        Backbone.trigger('change-currency');
        this.navigate(this.getPathFragment(), {
          trigger: true,
          replace: true,
        }, {
          currency: newCurrencyName,
        });
      }
    },

    /**
     * Обновление поискового запроса на странице
     * @param {Object} data - данные с поисковым запросом
     */
    updateSearchQueryOnPage: function (data) {
      if (data && data.query) {
        this.navigate('/', {
          trigger: true,
          replace: true,
        }, {
          'q': encodeURIComponent(data.query),
          'sort': this.collection.defaults.sort,
          'f': this.collection.defaults.f,
        });
      }
    },

    /**
     * Сохраняем переданные опции,
     * если они входят в массив attachedOptions
     * @param {Object} options
     */
    attachOptions: function (options) {
      if (!options) {
        return;
      }
      var optionList = _.union(this.attachedOptions, this.additionalOptions);
      optionList.forEach(function (optionName) {
        if (options[optionName]) {
          this[optionName] = options[optionName];
        }
      }.bind(this));
    },
    /**
     * Сбрасываем коллекцию в бесконечном моде.
     */
    infiniteFetch: function () {
      this.trigger('clear');
      this.collection.fullCollection.reset();
    },
    /**
     * Обрабатываем роут
     *
     * @param {String} page
     */
    handleRoute: function (page) {
      var params = app.helpers.UrlHelper.getUrlParameters(),
        changedParamsKeys,
        defaults = {
          'sort': this.collection.defaults.sort,
          'per-page': this.collection.defaults.pageSize,
          'viewtype': this.collection.defaults.viewtype,
          'f': this.collection.defaults.f,
          'mode': this.collection.defaults.mode,
          'correct': this.collection.defaults.correct,
          'q': this.collection.query,
          'qc': this.collection.defaults.qc,
          'currency': this.currency.name,
          'priority_ids': this.collection.defaults.priority_ids,
          'priority_sids': this.collection.defaults.priority_sids,
          'priority_parent_ids': this.collection.defaults.priority_parent_ids,
        };
      page = parseInt(params.page, 10) || parseInt(page, 10);
      // Если пришла строка с параметрами или в коллекции в бесконечном моде, ставим 1.
      page = page && this.collection.mode !== 'infinite' ? page : 1;
      if (!this.collection.fetchCounter
        || (this.collection instanceof app.Search && this.collection.fetchCounter === 1)
      ) {
        var cookieParams = this.getCookieParams();
        _.defaults(params, cookieParams);
        this.redirect(page, params);
      }
      params = this.validateParams(params, defaults);
      changedParamsKeys = this.getChangedParamKeys(params);
      _.defaults(params, defaults);
      // Если страница изменилась, добавляем в массив ключей изменившихся параметров
      if (this.collection.state.currentPage !== page) {
        changedParamsKeys.push('page');
      }
      if (changedParamsKeys.length) {
        this.updateCollectionParams(changedParamsKeys, params);
      }
      if (this.collection.fetchCounter === 0 || changedParamsKeys.length || this.forceFetch) {
        if (this.collection.mode === 'infinite') {
          if (!this.collection.fetchCounter) {
            this.trigger('infinite-scroll');
          }
          this.infiniteFetch();
        }
        try {
          this.collection.resetStatePageInfo();
          this.collection.getPage(page);
          this.forceFetch = false;
        } catch (e) {
          if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
            Raven.captureException(e);
          } else {
            throw e;
          }
        }
      }
      this.prevChangedParamsKeys = changedParamsKeys;
    },
    /**
     * Получает параметры, сохранённые в куки пользователя 'user_settings'
     * @returns {Object} Параметры из куки
     */
    getCookieParams: function () {
      var cookieParams = app.helpers.CookieHelper.getCookie('user_settings') || {};
      if (cookieParams.hasOwnProperty('per_page')) {
        cookieParams['per-page'] = cookieParams['per_page'];
        delete cookieParams['per_page'];
      }

      return _.pick(cookieParams, this.allowedCookieParams);
    },
    /**
     * Обрабатываем изменившиеся параметры, запуская соответствующие методы в коллекции.
     *
     * @param {Array} changedParamKeys
     * @param {Object} params
     */
    updateCollectionParams: function (changedParamKeys, params) {
      var that = this;
      var isChangedPriority = changedParamKeys.some(function (key) {
        return this.priorityKeys.includes(key);
      }.bind(this));
      changedParamKeys.forEach(function (key) {
        switch (key) {
          case 'sort':
            that.collection.setSort(params[key]);
            if (!isChangedPriority) {
              that.collection.unsetPriority();
            }
            break;
          case 'per-page':
            that.collection.setPageSize(params[key]);
            break;
          case 'viewtype':
            that.collection.setViewType(params[key]);
            break;
          case 'f':
            var needFpFilter = !_.isEmpty(app.filterUrlParam) && _.isObject(app.filterUrlParam);
            that.collection.setFilter(
              params[key],
              needFpFilter
                ? app.filterUrlParam
                : null
            );
            if (!isChangedPriority) {
              that.collection.unsetPriority();
            }
            break;
          case 'category':
            that.collection.setCategoryId(params[key]);
            break;
          case 'mode':
            that.collection.switchMode(params[key], {fetch: false});
            if (params.mode === 'infinite') {
              that.trigger('infinite-scroll');
              return;
            }
            break;
          case 'correct':
            that.collection.setCorrect(params[key]);
            that.trigger('change-correct');
            break;
          case 'q':
            that.collection.setQuery(params[key]);
            if (!isChangedPriority) {
              that.collection.unsetPriority();
            }
            break;
          case 'currency':
            if (!that.convertedFilters && typeof params.f === 'string' && params.f !== 'null') {
              if (that.convertPriceFilter(params)) {
                return;
              }
            }
            that.convertedFilters = false;
            that.collection.setCurrency(params[key]);
            that.trigger('change-currency');
            break;
          case 'priority_ids':
            that.collection.setPriorityIds(params[key]);
            break;
          case 'priority_sids':
            that.collection.setPrioritySids(params[key]);
            break;
          case 'priority_parent_ids':
            that.collection.setPriorityParentIds(params[key]);
            break;
        }
      });
      this.trigger('change-get-params', changedParamKeys, this.type);
    },
    /**
     * Валидируем полученные параметры. Если не прошли, ставим дефолтное значение.
     *
     * @param {Object} params
     * @param {Object} defaultParams
     *
     * @returns {*}
     */
    validateParams: function (params, defaultParams) {
      var that = this;
      // Валидируем полученные из урла параметры
      _.each(params, function (param, key) {
        if (key === 'per-page') {
          var allowedPageSize = app.features.is_stripped_per_page_segments ? [20] : [20, 50, 100];
          param = parseInt(param, 10);
          if (allowedPageSize.indexOf(param) === -1) {
            param = that.collection.state.pageSize;
          }
        }
        if (key === 'mode') {
          var allowedMods = ['server', 'infinite'];
          if (app.isMobile) {
            allowedMods = [defaultParams.mode];
          }
          if (allowedMods.indexOf(param) === -1) {
            param = that.collection.mode;
          }
        }
        return _.indexOf(that.allowed, key) >= 0 ? params[key] = param : params[key] = defaultParams[key];
      });
      return params;
    },
    /**
     * Получаем массив ключей изменившихся параметров.
     *
     * @param {Object} params объект гет параметров запроса.
     *
     * @returns {Array} массив ключей изменившихся параметров.
     */
    getChangedParamKeys: function (params) {
      var currentParams = {
          'sort': this.collection.sort,
          'per-page': this.collection.state.pageSize,
          'viewtype': this.collection.viewtype,
          'f': this.collection.filter,
          'mode': this.collection.mode,
          'correct': this.collection.correct,
          'q': this.collection.query,
          'currency': this.collection.currencyId,
          'priority_ids': this.collection.priority_ids,
          'priority_sids': this.collection.priority_sids,
          'priority_parent_ids': this.collection.priority_parent_ids,
        },
        keys = _.union(_.keys(params), this.prevChangedParamsKeys);
      return _.filter(keys, function (key) {
         return params[key] !== currentParams[key];
      });
    },
    /**
     * Получает фрагмент URL без параметров относительно корня Backbone.History
     * @returns {String} Фрагмент URL
     */
    getPathFragment: function () {
      var fragment = Backbone.history.getFragment().split('?')[0];
      if (app.baseFilterPageUrl) {
        fragment = '';
      }
      return fragment;
    },
    /**
     * Редиректит на страницу без перезагрузки
     * @param {Number} page Номер страницы, если не указан, то 1.
     * @param {Object} params Параметры страницы.
     */
    redirect: function (page, params) {
      if (!page || typeof page !== 'number') {
        page = 1;
      }
      if (!params) {
        params = {};
      }
      var url = '/';
      if (page > 1) {
        url = 'p' + page + '/';
      }
      this.navigate(url, {
        trigger: false,
        replace: true
      }, params);
    },
    /**
     * Определяет сохраняемые параметры
     * @param {Object} params Новые параметры
     * @returns {Array} Сохраняемые параметры
     */
    getSavedParams: function (params) {
      params = params || {};
      var allParams = this.allowed.concat(this.navigateParams),
        result = [],
        baseLength = allParams.length;
      for (var i = 0; i < baseLength; i += 1) {
        var allowedKey = allParams[i];
        if (
          !params.hasOwnProperty(allowedKey)
          && !(this.priorityKeys.indexOf(allowedKey) !== -1 && (params.sort || params.f || params.q))
        ) {
          result.push(allowedKey);
        }
      }

      return result;
    },
    /**
     * При смене валюты, конвертирует значения price фильтра в новую валюту
     * @param {Object} params Объект с параметрами
     * @returns {Boolean} случилась ли конвертация
     */
    convertPriceFilter: function (params) {
      try {
        var filters = JSON.parse(params.f),
          currentRate,
          newRate;
        if (filters && filters.price) {
          currentRate = parseFloat(this.currencies.findWhere({name: this.collection.currencyId}).get('rate'));
          newRate = parseFloat(this.currency.rate);
          if (filters.price[0]) {
            filters.price[0] = Math.floor(((parseInt(filters.price[0], 10) * currentRate) / newRate));
          }
          if (filters.price[1]) {
            filters.price[1] = Math.ceil(((parseInt(filters.price[1], 10) * currentRate) / newRate));
          }
          // Если фильтры были сконвертированы
          this.convertedFilters = true;
          this.navigate(this.getPathFragment(), {
            trigger: true,
            replace: false
          }, {
            'f': JSON.stringify(filters)
          });
          return true;
        }
      } catch (e) {
        if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
          Raven.captureException(e);
        } else {
          throw e;
        }
        return false;
      }

    },
    /**
     * Переопределяет стандартный Backbone.Router.navigate,
     * чтобы можно было автоматически подставлять сохраняемые параметры
     *
     * @param {String} url URL или фрагмент URL
     * @param {Object} options Опции навигации
     * @param {Object} params Объект с новыми параметрами
     */
    navigate: function (url, options, params) {
      this.isRouterNavigate = true;
      if (_.isFunction(params)) {
        params = params();
      }
      if (params && (!_.isObject(params) || _.isArray(params) || _.isFunction(params))) {
        params = false;
      }
      if (params) {
        url = app.helpers.UrlHelper.to(url, this.getSavedParams(params), params, false);
      }
      // При обновлении страницы без перезагрузки referrer не меняется и в око отправляется некорректный 'ref'
      // приходится назначать вручную при каждом переходе
      if (typeof oko !== 'undefined' ) {
        oko.info['ref'] = document.documentURI;
      }
      Backbone.Router.prototype.navigate.apply(this, [url, options]);
    }
  });
}());

}.call(window));